
const m = window.require("@ember/template-factory");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
